import Map from '@material-ui/icons/Map';
import Tune from '@material-ui/icons/Tune';
import { ReactElement, useMemo } from 'react';
import {
	MenuOption,
	MoreOptionsBase
} from '../more-options-base/more-options-base.component';
import { useIsWildcardUser, useOpcoUrlPrefix } from '../../../hooks';
import { MapDetailDto } from '../../../models';
import { Project } from '../../../redux';
import { useTranslation } from 'react-i18next';

export interface IProjectMoreOptionsProps {
	project: Project;
	map: MapDetailDto;
	onSave: () => void;
	onSaveAs: () => void;
	onHandIn: () => void;
	onShare: () => void;
}

export function ProjectMoreOptions(
	props: IProjectMoreOptionsProps
): ReactElement {
	const { project, map, onSave, onSaveAs, onHandIn, onShare } = props;
	const { t } = useTranslation('project');

	const isWildcardUser: boolean = useIsWildcardUser();
	const opcoPrefix: string = useOpcoUrlPrefix();

	const optionsToShow: MenuOption[] = useMemo<MenuOption[]>(() => {
		return [
			{
				isShown: isWildcardUser,
				buttonParams: {
					icon: <Tune />,
					text: t('button.navigateMetadata'),
					onClick: () =>
						navigateTo(`/${opcoPrefix}/manage/metadata/${map.id}`)
				}
			},
			{
				isShown: isWildcardUser,
				buttonParams: {
					icon: <Map />,
					text: t('button.navigateAsset'),
					onClick: () =>
						navigateTo(
							`/${opcoPrefix}/manage/metadata/${map.assetId}`
						)
				}
			}
		];
	}, [isWildcardUser, map, opcoPrefix]);

	function navigateTo(url: string): void {
		window.open(url, '_blank');
	}

	return (
		<MoreOptionsBase
			data={project}
			objectDescriptor="map"
			options={optionsToShow}
			onHandIn={onHandIn}
			onSave={onSave}
			onSaveAs={onSaveAs}
			onShare={onShare}
		/>
	);
}
